import React, { memo } from 'react';
import classnames from 'classnames';
import { initVisitor } from '@laigu/utils';

import MyIcon from '../my-icon';

import style from './index.less';

interface MyAvatarProps {
  visitInfo?: VisitInfo;
  className?: string;
  size?: number;
}

// 头像对应iconfont的type
type SrcMap = {
  [key: string]: string;
};

const srcMap: SrcMap = {
  sdk: 'sdk-empty-icon',
  ios: 'ios-sdk-circle',
  android: 'android-sdk-circle',
  weixin: 'wechat-circle',
  weibo: 'weibo-circle',
  sm: 'sm-circle',
  yahoo: 'yahoo-circle',
  sogou: 'sogou-circle',
  baidu: 'baidu-circle',
  google: 'google-circle',
  bing: 'bing-circle',
  '360search': '360search-circle',
  toutiaosearch: 'toutiao_circle',
  phone: 'phone-circle',
  computer: 'computer-circle',
  unknown: 'unknown-circle',
  baidu_bcp: 'baidu-circle',
  baidu_web: 'baidu-circle',
  kuaishou: 'kuaishou',
  toutiao_microapp: 'toutiao',
  toutiao: 'toutiao_circle',
  douyin: 'douyin1',
  redbook: 'xhs1'
};

type Avatar = React.FC<MyAvatarProps>;

// change by wangxing 直接传入size确定大小，不需要再到处的写样式
const Avatar: Avatar = memo(
  ({ visitInfo = {}, className = '', size = 36 }: MyAvatarProps): JSX.Element => {
    const imageRef = React.useRef(null);
    const { type, src = 'unknown' } = React.useMemo(() => {
      return initVisitor(visitInfo)?.avatar || {};
    }, [visitInfo]);

    const isImage = type === 'image';
    const myIconStyle: React.CSSProperties | undefined = {
      fontSize: size
    };
    return (
      <div className={classnames(style['avatar-box'], 'avatar-box')}>
        {isImage ? (
          <img
            ref={imageRef}
            className={classnames(className)}
            style={{ height: size, width: size }}
            src={src}
            alt=''
          />
        ) : (
          <MyIcon
            style={myIconStyle}
            type={`ecoboost-iconfont${srcMap[src]}`}
            className={classnames(className)}
            title=''
          />
        )}
      </div>
    );
  }
);

export default Avatar;
